function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVe(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    width: "10.583mm",
    height: "10.583mm",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "BG"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ebene_11",
    "data-name": "Ebene_1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M0,5h30v20H0V5Z",
    style: {
      fill: "#cf142b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,18.333h30V5H0v13.333Z",
    style: {
      fill: "#00247d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,5h30v6.667H0v-6.667Z",
    style: {
      fill: "#fc0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M8.579,16.563l.682.533.32-.409-1.002-.124Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "a1",
    "data-name": "a",
    d: "M8.579,16.563l.865.03-.018.519-.847-.549Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "a2",
    "data-name": "a",
    d: "M9.422,15.994l-.296.813.488.178-.192-.991Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "a3",
    "data-name": "a",
    d: "M9.422,15.994l.239.832-.499.143.26-.975Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "a4",
    "data-name": "a",
    d: "M8.859,17.541l.717-.484-.29-.43-.427.914Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "a5",
    "data-name": "a",
    d: "M8.859,17.541l.296-.813.488.178-.784.635Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "a6",
    "data-name": "a",
    d: "M10.224,16.621l-.865-.03-.018.519.883-.489Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "a7",
    "data-name": "a",
    d: "M10.224,16.621l-.717.484-.29-.43,1.007-.054Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "a8",
    "data-name": "a",
    d: "M9.876,17.577l-.239-.832-.499.143.738.689Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "a9",
    "data-name": "a",
    d: "M9.876,17.577l-.682-.533.32-.409.362.942Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "a10",
    "data-name": "a",
    d: "M9.854,14.587l.405.764.459-.243-.864-.521Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "a11",
    "data-name": "a",
    d: "M9.854,14.587l.777.38-.228.466-.549-.846Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "a12",
    "data-name": "a",
    d: "M10.856,14.411l-.602.622.373.361.229-.983Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "a13",
    "data-name": "a",
    d: "M10.856,14.411l-.121.857-.514-.073.635-.784Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "a14",
    "data-name": "a",
    d: "M9.711,15.594l.852-.149-.09-.511-.762.66Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "a15",
    "data-name": "a",
    d: "M9.711,15.594l.602-.622.373.361-.975.261Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "a16",
    "data-name": "a",
    d: "M11.332,15.31l-.777-.38-.228.466,1.005-.086Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "a17",
    "data-name": "a",
    d: "M11.332,15.31l-.852.149-.09-.511.942.362Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "a18",
    "data-name": "a",
    d: "M10.625,16.041l.121-.857-.514-.073.393.93Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "a19",
    "data-name": "a",
    d: "M10.625,16.041l-.405-.765.459-.243-.054,1.008Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "a20",
    "data-name": "a",
    d: "M11.629,13.191l.18.846.508-.108-.688-.738Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "a21",
    "data-name": "a",
    d: "M11.629,13.191l.643.579-.347.386-.296-.965Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "a22",
    "data-name": "a",
    d: "M12.641,13.297l-.749.433.26.45.489-.883Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "a23",
    "data-name": "a",
    d: "M12.641,13.297l-.352.791-.474-.211.826-.58Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "a24",
    "data-name": "a",
    d: "M11.216,14.12l.861.09.054-.516-.915.426Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "a25",
    "data-name": "a",
    d: "M11.216,14.12l.749-.433.26.45-1.009-.017Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "a26",
    "data-name": "a",
    d: "M12.853,14.292l-.643-.579-.347.386.99.193Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "a27",
    "data-name": "a",
    d: "M12.853,14.292l-.861-.09.054-.516.807.606Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "a28",
    "data-name": "a",
    d: "M11.972,14.801l.352-.79-.474-.211.122,1.001Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "a29",
    "data-name": "a",
    d: "M11.972,14.801l-.18-.846.508-.108-.328.954Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "a30",
    "data-name": "a",
    d: "M13.807,12.418l-.12.857.514.072-.394-.929Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "a31",
    "data-name": "a",
    d: "M13.807,12.418l.406.764-.458.244.052-1.008Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "a32",
    "data-name": "a",
    d: "M14.721,12.864l-.852.15.09.511.762-.661Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "a33",
    "data-name": "a",
    d: "M14.721,12.864l-.601.622-.373-.361.974-.261Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "a34",
    "data-name": "a",
    d: "M13.1,13.149l.778.379.228-.467-1.006.088Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "a35",
    "data-name": "a",
    d: "M13.1,13.149l.852-.15.09.511-.942-.361Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "a36",
    "data-name": "a",
    d: "M14.579,13.871l-.406-.764-.458.244.864.52Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "a37",
    "data-name": "a",
    d: "M14.579,13.871l-.778-.379.228-.467.55.846Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "a38",
    "data-name": "a",
    d: "M13.578,14.047l.601-.622-.373-.361-.228.983Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "a39",
    "data-name": "a",
    d: "M13.578,14.047l.12-.857.514.072-.634.785Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "a40",
    "data-name": "a",
    d: "M21.43,16.563l-.682.533-.32-.409,1.002-.124Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "a41",
    "data-name": "a",
    d: "M21.43,16.563l-.865.03.018.519.847-.549Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "a42",
    "data-name": "a",
    d: "M20.586,15.994l.296.813-.488.178.192-.991Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "a43",
    "data-name": "a",
    d: "M20.586,15.994l-.239.832.499.143-.26-.975Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "a44",
    "data-name": "a",
    d: "M21.149,17.541l-.717-.484.29-.43.427.914Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "a45",
    "data-name": "a",
    d: "M21.149,17.541l-.296-.813-.488.178.784.635Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "a46",
    "data-name": "a",
    d: "M19.785,16.621l.865-.03.018.519-.883-.489Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "a47",
    "data-name": "a",
    d: "M19.785,16.621l.717.484.29-.43-1.007-.054Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "a48",
    "data-name": "a",
    d: "M20.133,17.577l.239-.832.499.143-.738.689Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "a49",
    "data-name": "a",
    d: "M20.133,17.577l.682-.533-.32-.409-.362.942Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "a50",
    "data-name": "a",
    d: "M20.155,14.587l-.405.764-.459-.243.864-.521Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "a51",
    "data-name": "a",
    d: "M20.155,14.587l-.777.38.228.466.549-.846Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "a52",
    "data-name": "a",
    d: "M19.153,14.411l.602.622-.373.361-.229-.983Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "a53",
    "data-name": "a",
    d: "M19.153,14.411l.121.857.514-.073-.635-.784Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "a54",
    "data-name": "a",
    d: "M20.297,15.594l-.852-.149.09-.511.762.66Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "a55",
    "data-name": "a",
    d: "M20.297,15.594l-.602-.622-.373.361.975.261Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "a56",
    "data-name": "a",
    d: "M18.676,15.31l.777-.38.228.466-1.005-.086Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "a57",
    "data-name": "a",
    d: "M18.676,15.31l.852.149.09-.511-.942.362Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "a58",
    "data-name": "a",
    d: "M19.384,16.041l-.121-.857.514-.073-.393.93Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "a59",
    "data-name": "a",
    d: "M19.384,16.041l.405-.765-.459-.243.054,1.008Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "a60",
    "data-name": "a",
    d: "M18.379,13.191l-.18.846-.508-.108.688-.738Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "a61",
    "data-name": "a",
    d: "M18.379,13.191l-.643.579.347.386.296-.965Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "a62",
    "data-name": "a",
    d: "M17.367,13.297l.749.433-.26.45-.489-.883Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "a63",
    "data-name": "a",
    d: "M17.367,13.297l.352.791.474-.211-.826-.58Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "a64",
    "data-name": "a",
    d: "M18.793,14.12l-.861.09-.054-.516.915.426Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "a65",
    "data-name": "a",
    d: "M18.793,14.12l-.749-.433-.26.45,1.009-.017Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "a66",
    "data-name": "a",
    d: "M17.156,14.292l.643-.579.347.386-.99.193Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "a67",
    "data-name": "a",
    d: "M17.156,14.292l.861-.09-.054-.516-.807.606Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "a68",
    "data-name": "a",
    d: "M18.037,14.801l-.352-.79.474-.211-.122,1.001Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "a69",
    "data-name": "a",
    d: "M18.037,14.801l.18-.846-.508-.108.328.954Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "a70",
    "data-name": "a",
    d: "M16.202,12.418l.12.857-.514.072.394-.929Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "a71",
    "data-name": "a",
    d: "M16.202,12.418l-.406.764.458.244-.052-1.008Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "a72",
    "data-name": "a",
    d: "M15.288,12.864l.852.15-.09.511-.762-.661Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "a73",
    "data-name": "a",
    d: "M15.288,12.864l.601.622.373-.361-.974-.261Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "a74",
    "data-name": "a",
    d: "M16.909,13.149l-.778.379-.228-.467,1.006.088Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "a75",
    "data-name": "a",
    d: "M16.909,13.149l-.852-.15-.09.511.942-.361Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "a76",
    "data-name": "a",
    d: "M15.429,13.871l.406-.764.458.244-.864.52Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "a77",
    "data-name": "a",
    d: "M15.429,13.871l.778-.379-.228-.467-.55.846Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "a78",
    "data-name": "a",
    d: "M16.431,14.047l-.601-.622.373-.361.228.983Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "a79",
    "data-name": "a",
    d: "M16.431,14.047l-.12-.857-.514.072.634.785Z",
    style: {
      fill: "#fff"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVe);
export default __webpack_public_path__ + "static/media/VE.023eafc559c20ce91901c4c5860b434e.svg";
export { ForwardRef as ReactComponent };